import type { ReactNode } from "react";
import { HStack, Switch, Text } from "@chakra-ui/react";
import { useController, useFormContext } from "react-hook-form";

export type PreferenceSwitchProps = {
  name: string;
  label: string;
  helperPopup?: ReactNode;
};

export function PreferenceSwitch({
  label,
  name,
  helperPopup,
}: PreferenceSwitchProps) {
  const { control } = useFormContext();
  const { field } = useController({ control, name });
  return (
    <HStack w={"100%"}>
      <HStack flexGrow={1} gap={0} alignContent={"center"}>
        <Text fontSize={"medium"} color={"grey.700"} fontWeight={500}>
          {label}
        </Text>
        {helperPopup}
      </HStack>
      <Switch {...field} isChecked={field.value} colorScheme={"indigo"} />
    </HStack>
  );
}
